module.exports = __webpack_public_path__ + "img/saishianpai-icon-2.242ec2d4.png";